(() => {
  if (window.bdmVideoGalleryReady) return;
  window.bdmVideoGalleryReady = true;

  const toEmbedUrl = (rawUrl) => {
    try {
      const url = new URL(rawUrl, window.location.origin);
      const host = url.hostname.replace(/^www\./, "");
      if (host === "youtu.be") {
        return { type: "iframe", url: `https://www.youtube-nocookie.com/embed/${url.pathname.slice(1)}?autoplay=1&playsinline=1` };
      }
      if (host.endsWith("youtube.com")) {
        const id = url.searchParams.get("v") || url.pathname.split("/").filter(Boolean).pop();
        if (id) return { type: "iframe", url: `https://www.youtube-nocookie.com/embed/${id}?autoplay=1&playsinline=1` };
      }
      if (host.endsWith("vimeo.com")) {
        const id = url.pathname.split("/").filter(Boolean).pop();
        if (id) return { type: "iframe", url: `https://player.vimeo.com/video/${id}?autoplay=1` };
      }
      return { type: "video", url: url.toString() };
    } catch (_) {
      return { type: "video", url: rawUrl };
    }
  };

  const playCard = async (card) => {
    const button = card.querySelector("[data-bdm-video-play]");
    const poster = card.querySelector(".bdm-video-card__poster");
    const video = card.querySelector("[data-bdm-video]");
    const embed = card.querySelector("[data-bdm-video-embed]");

    button?.setAttribute("hidden", "");
    poster?.setAttribute("hidden", "");
    card.classList.add("is-playing");

    if (video) {
      video.hidden = false;
      try { await video.play(); } catch (_) { /* user can use native controls */ }
      return;
    }

    if (!embed || embed.dataset.loaded === "true") return;
    const source = toEmbedUrl(embed.dataset.videoUrl || "");
    embed.hidden = false;
    embed.dataset.loaded = "true";
    if (source.type === "iframe") {
      const iframe = document.createElement("iframe");
      iframe.src = source.url;
      iframe.title = "Video";
      iframe.allow = "autoplay; encrypted-media; picture-in-picture";
      iframe.allowFullscreen = true;
      iframe.loading = "lazy";
      embed.append(iframe);
    } else {
      const externalVideo = document.createElement("video");
      externalVideo.src = source.url;
      externalVideo.controls = true;
      externalVideo.autoplay = true;
      externalVideo.playsInline = true;
      externalVideo.preload = "metadata";
      embed.append(externalVideo);
    }
  };

  const updateProgress = (gallery) => {
    const track = gallery.querySelector("[data-bdm-video-track]");
    const bar = gallery.querySelector("[data-bdm-video-progress]");
    if (!track) return;
    const max = track.scrollWidth - track.clientWidth;
    const progress = max > 0 ? track.scrollLeft / max : 0;
    if (bar) bar.style.setProperty("--bdm-video-progress", `${Math.max(0, Math.min(1, progress)) * 100}%`);

    const previous = gallery.querySelector("[data-bdm-video-prev]");
    const next = gallery.querySelector("[data-bdm-video-next]");
    if (previous) previous.disabled = max <= 2 || track.scrollLeft <= 2;
    if (next) next.disabled = max <= 2 || track.scrollLeft >= max - 2;
  };

  const updateLayout = (gallery) => {
    const track = gallery.querySelector("[data-bdm-video-track]");
    if (!track) return;
    const scrollable = track.scrollWidth > track.clientWidth + 2;
    gallery.classList.toggle("is-scrollable", scrollable);
    const footer = gallery.querySelector("[data-bdm-video-footer]");
    if (footer) footer.hidden = !scrollable;
    updateProgress(gallery);
  };

  const scrollGallery = (gallery, direction) => {
    const track = gallery.querySelector("[data-bdm-video-track]");
    const card = track?.querySelector("[data-bdm-video-card]");
    if (!track || !card) return;
    const styles = getComputedStyle(track);
    const gap = parseFloat(styles.columnGap || styles.gap || "0") || 0;
    const distance = card.getBoundingClientRect().width + gap;
    track.scrollBy({ left: direction * distance, behavior: "smooth" });
  };

  document.addEventListener("click", (event) => {
    const button = event.target.closest("[data-bdm-video-play]");
    if (button) {
      event.preventDefault();
      const card = button.closest("[data-bdm-video-card]");
      if (card) playCard(card);
      return;
    }
    const previous = event.target.closest("[data-bdm-video-prev]");
    const next = event.target.closest("[data-bdm-video-next]");
    const control = previous || next;
    if (!control) return;
    event.preventDefault();
    const gallery = control.closest("[data-bdm-video-gallery]");
    if (gallery) scrollGallery(gallery, previous ? -1 : 1);
  });

  const init = (gallery) => {
    if (gallery.dataset.bdmVideoInit === "true") return;
    gallery.dataset.bdmVideoInit = "true";
    const track = gallery.querySelector("[data-bdm-video-track]");
    if (!track) return;
    let frame = 0;
    track.addEventListener("scroll", () => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => updateProgress(gallery));
    }, { passive: true });
    updateLayout(gallery);
    if ("ResizeObserver" in window) {
      const observer = new ResizeObserver(() => updateLayout(gallery));
      observer.observe(track);
      gallery.querySelectorAll("[data-bdm-video-card]").forEach((card) => observer.observe(card));
    } else {
      window.addEventListener("resize", () => updateLayout(gallery), { passive: true });
    }
  };

  const initAll = (root = document) => root.querySelectorAll("[data-bdm-video-gallery]").forEach(init);
  initAll();
  document.addEventListener("shopify:section:load", (event) => initAll(event.target));
})();
